"use client";

import NextTopLoader from "nextjs-toploader";

const TopLoadingBar = () => {
  let ResolvedLoader = NextTopLoader;
  if ("default" in ResolvedLoader) {
    ResolvedLoader = (ResolvedLoader as unknown as { default: typeof NextTopLoader }).default;
  }

  return <ResolvedLoader color="#6F5DFF" showSpinner={false} />;
};

export default TopLoadingBar;
